import * as Yup from 'yup';

const Schema = Yup.object().shape({
  comment: Yup.string().required('El comentario es requerido'),
  option: Yup.string().required('El tipo de consulta es requerido'),
});

export default Schema;
